var router = {
    name: 'SavInfo',
    url_keyname: '/',
    api_keyname: null,
    mobile: 1,
    translates: true,
}

export default router



// WEBPACK FOOTER //
// ./src/companies/default/configs/default.conf.js